import { TranslationKey } from './types';

export default {
	DEFERRED_PAYMENT_BANNER_1:
		'Plaťte pohodlne až po\u00A0doručení a\u00A0vyskúšaní tovaru. Zadarmo a\u00A0bez navýšenia.',
	DEFERRED_PAYMENT_BANNER_2: 'Dnes za\u00A00\u00A0€, zvyšok o\u00A030\u00A0dní.',
	PAY_IN_THREE_BANNER_1:
		'Rozdeľte si platbu na\u00A0tretiny. Prvú zaplatíte ihneď, zvyšné dve o\u00A030\u00A0a\u00A060\u00A0dní. Zadarmo a\u00A0bez navýšenia.',
	PAY_IN_THREE_BANNER_WITH_AMOUNT:
		'Zaplaťte v 3\u00A0platbách vo výške {amount}. Zadarmo a\u00A0bez navýšenia.',
	MORE_INFO: 'Ako\u00A0na\u00A0to?',
	DEFERRED_PAYMENT_MODAL_TITLE: 'Nakupujte teraz, zaplaťte o\u00A030\u00A0dní',
	DEFERRED_PAYMENT_MODAL_SUB_TITLE: 'Zadarmo a\u00A0bez navýšenia',
	DEFERRED_PAYMENT_MODAL_STEP_1: 'Pridajte tovar do\u00A0košíka.',
	DEFERRED_PAYMENT_MODAL_STEP_2:
		'Z\u00A0ponuky platobných metód vyberte Odloženú platbu Skip\u00A0Pay.',
	DEFERRED_PAYMENT_MODAL_STEP_3:
		'Hotovo. Nákup zaplatíte až po\u00A0tom, ako si ho doma v\u00A0pokoji vyskúšate. Máte na\u00A0to až 30\u00A0dní.',
	MODAL_MORE_INFO: 'Viac\u00A0informácií',
	PAY_IN_THREE_MODAL_TITLE: 'Rozdeľte si platbu nákupu na\u00A0tretiny',
	PAY_IN_THREE_MODAL_SUB_TITLE: 'Zadarmo a\u00A0bez navýšenia',
	PAY_IN_THREE_MODAL_STEP_1:
		'Z\u00A0ponuky platobných metód v\u00A0košíku vyberte nákup na\u00A0Tretinu so\u00A0Skip\u00A0Pay.',
	PAY_IN_THREE_MODAL_STEP_1_DYNAMIC:
		'V\u00A0košíku vyberte ako spôsob platby Nákup na Tretinu\u00A0od\u00A0Skip Pay.',
	PAY_IN_THREE_MODAL_STEP_2: 'Prvú tretinu ceny nákupu uhraďte platobnou\u00A0kartou.',
	PAY_IN_THREE_MODAL_STEP_3: 'Hotovo. Zvyšné dve tretiny doplatíte za\u00A030 a\u00A060\u00A0dní.',
	PAY_IN_THREE_MODAL_PAY_TODAY: 'Platíte dnes',
	PAY_IN_THREE_UNTIL: 'do',
	CLOSE_MODAL: 'Zavrieť',
} as Record<TranslationKey, string>;
